import React from "react";
import { Link } from "react-router-dom";
import SEO from "../SEO/SEO.jsx";
import TestimonialSlider from "../TestimonialSlider/TestimonialSlider.jsx";
import BannerCarousel from "../BannerCarousel/BannerCarousel.jsx";

const Home = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="middle">
      <SEO
        title={"Doorstep Car Wash in Jaipur | Eco-Friendly Car Cleaning at Home – WashWoosh"}
        description={
          "Eco-friendly doorstep car cleaning in Jaipur. We serve Jagatpura, Pratap Nagar, Sanganer, Gopalpura, Durgapura & Malviya Nagar. Book WashWoosh now and try our quarterly plan with monthly perks!"
        }
        canonical={"https://washwoosh.com/"}
      />
      <BannerCarousel />

      <div className="header-banner">
        <video
          className="bg-video"
          width="100%"
          height="550px"
          muted
          autoPlay
          playsInline
          loop
          preload="auto"
        >
          <source src="images/movie.mp4" type="video/mp4" />
        </video>

        <div className="container">
          <div className="row banner-men items-center justify-center">
            <div className="col-lg-6 col-md-6">
              <div className="banner-text">
                <h1>
                  Doorstep Car Wash in Jaipur –<span>Shine Without Stepping Out</span>
                </h1>
                <h5 className="mt-3">Keep your car spotless with WashWoosh – <strong className="highlight-text">Jaipur’s #1</strong> doorstep car wash service.</h5>
                <p>We bring <strong className="highlight-text">eco-friendly, water-efficient car cleaning</strong> right to your home or office. No queues. No hassle. Just a sparkling clean car – daily or monthly! <br />We are currently serving Malviya Nagar, Jagatpura, Pratap Nagar, Gopalpura, Durgapura, and Sanganer. More locations coming soon!
                </p>
                
                <div className="all-btn">
                  <div className="row">
                    <div className="col-lg-3 playapp">
                      <div className="btn1">
                        <a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Play Store For Android Users">
                          <img className="img-fluid" src="images/d-app1.png" alt="Play Store Icon" />
                        </a>
                      </div>
                      <div className="btn1">
                        <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For iOS Users">
                          <img className="img-fluid" src="images/d-app2.png" alt="App Store Icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6">
              <div
                className="banner-text banner-text-one text-end"
                data-aos="flip-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration={2000}
              >
                <img
                  className="img-fluid"
                  src="images/banner-photo.png"
                  alt="Banner"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="our-services-men">
        <div className="container">
          <div className="heading-men">
            <h2>Our Services</h2>
            <p>
              Experience<strong className="font-md"> hassle-free car care</strong> with our
              <strong className="font-md"> eco-friendly</strong> and
              <strong className="font-md"> affordable</strong> car wash services.
            </p>
          </div>
          <div className="row mt-4">
            {[
              {
                title: "Basic Exterior Wash",
                img: "images/icon1.png",
                desc: "A quick and efficient wash that removes dirt and dust...",
              },
              {
                title: "Complete Exterior & Interior Cleaning",
                img: "images/icon2.png",
                desc: "A thorough cleaning service that includes...",
              },
              {
                title: "Eco-Friendly Waterless Car Wash",
                img: "images/icon3.png",
                desc: "An eco-friendly solution that uses advanced cleaning...",
              },
              {
                title: "Flexible Subscription Plans",
                img: "images/icon4.png",
                desc: "Daily & Monthly Plans, Quarterly Plan",
              },
            ].map((service, idx) => (
              <div key={idx} className="col-lg-3 col-md-6" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration={2000}>
                <div className="our-services-one">
                  <img className="img-fluid" src={service.img} alt={`${service.title} Icon`} />
                  <h2>{service.title}</h2>
                  <p>{service.desc}</p>
                  <div className="book-mafia mt-4">
                    <Link to="/services" onClick={handleLinkClick}>
                      <a className="btn service-read-btn" aria-label={`Read more about ${service.title}`}>
                        <span>Read More ⇾</span>
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="middle-banner">
        <div className="container-fluid p-0">
          <div className="middle-banner-text" data-aos="zoom-in" data-aos-easing="ease-out-cubic" data-aos-duration={2000}>
            <img className="img-fluid" src="images/middle-banner.png" alt="Banner" />
          </div>
        </div>
      </div>

      <div className="about-why-choose why-chooseus-men">
        <div className="container chooseus-text">
          <div className="heading-men">
            <h2>Why Choose Us?</h2>
            <p>WashWoosh isn’t just another car wash service—it’s a game-changer in car care that combines convenience, quality, and eco-friendly practices. Here’s what makes us the preferred choice for <strong className="font-md">doorstep car cleaning services in Jaipur</strong></p>
          </div>
          <div className="row mt-4 align-items-center">
            {/* Left Column */}
            <div className="col-lg-6 col-md-6" data-aos="fade-down" data-aos-duration={2000}>
              {[
                {
                  img: "images/cleaning-at-your-door.png",
                  title: "Car Cleaning at Your Doorstep",
                  desc: "No need to drive to a service center. Our professional cleaners come to your home, office, or any location of your choice, saving you time and effort.",
                },
                {
                  img: "images/expert-skilled-cleaners.png",
                  title: "Expert & Skilled Cleaners",
                  desc: "Our team of <strong class='font-sm-dark'>trained car cleaners in Jaipur</strong> uses advanced tools and techniques to deliver a thorough, scratch-free clean every time.",
                },
                {
                  img: "images/ecofriendly-cleaning-to.png",
                  title: "Eco-Friendly Cleaning",
                  desc: "We use minimal water and biodegradable cleaning products, ensuring a spotless shine while reducing environmental impact.",
                },
              ].map((item, index) => (
                <div key={index} className={`col-lg-12 col-md-12 ${index === 1 ? "mt-4 mb-4" : index === 2 ? "why-choose-mb" : ""}`}>
                  <div className="why-chooseus-one">
                    <img className="img-fluid" src={item.img} alt={item.title} />
                    <h2>{item.title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: item.desc }} />
                  </div>
                </div>
              ))}
            </div>

            {/* Right Column */}
            <div className="col-lg-6 col-md-6" data-aos="zoom-in-up" data-aos-duration={2000}>
              {[
                {
                  img: "images/affordable.png",
                  title: "Affordable & Transparent Pricing",
                  desc: "Enjoy competitive rates with no hidden charges—quality service at a price that fits your budget.",
                },
                {
                  img: "images/whyicon2.svg",
                  title: "Reliable & On-Time Service",
                  desc: "We respect your schedule, arriving on time and delivering efficient, hassle-free service.",
                },
                {
                  img: "images/flexible-subscription.png",
                  title: "Flexible Subscription Plans",
                  desc: "Choose from <strong class='font-sm-dark'>Daily, Monthly, Quarterly</strong>, or <strong class='font-sm-dark'>Annual</strong> plans. Our <strong class='font-sm-dark'>Quarterly Plan</strong> is a user favorite, with perks like a <strong class='font-sm-dark'>car freshener</strong> and <strong class='font-sm-dark'>tissue paper box</strong> with each service.",
                },
              ].map((item, index) => (
                <div key={index} className={`col-lg-12 col-md-12 ${index === 1 ? "mt-4 mb-4" : ""}`}>
                  <div className="why-chooseus-one">
                    <img className="img-fluid" src={item.img} alt={item.title} />
                    <h2>{item.title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: item.desc }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <TestimonialSlider />

      <div className="At-fingertips-men">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12" data-aos="zoom-in" data-aos-duration={2000}>
              <div className="At-fingertips-left">
                <div className="heading-men p-0">
                  <img className="app-icon-photo" src="images/app-icon.png" alt="App Icon" />
                  <h2>At your doorstep, at your fingertips</h2>
                  <p className="pt-2">
                    Experience the most convenient, professional, and eco-friendly car wash solution—just a tap away!
                  </p>
                  <div className="all-btn">
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-2 play">
                        <div className="btn1 btn2">
                          <a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Play Store For Android Users">
                            <img className="img-fluid" src="images/d-app1.png" alt="Play Store Icon" />
                          </a>
                        </div>
                        <div className="btn1 btn2">
                          <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For iOS Users">
                            <img className="img-fluid" src="images/d-app2.png" alt="App Store Icon" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
